export function createEventManager() {
    return {
        calculatorReady: subscriberAndNotifierNoPayload(),
        patch: subscriberAndNotifier(),
        serviceSuccess: subscriberAndNotifier()
    };
}
const emptyNotifier = {
    notify: () => { },
    subscribe: () => () => { }
};
export const emptyEventManager = {
    calculatorReady: emptyNotifier,
    patch: emptyNotifier,
    serviceSuccess: emptyNotifier
};
const subscriberAndNotifier = () => {
    let count = 0;
    const myMap = new Map();
    return {
        notify: (msg) => {
            myMap.forEach(fn => fn(msg));
        },
        subscribe: (cb) => {
            const instance = count++;
            myMap.set(instance, cb);
            return () => {
                myMap.delete(instance);
            };
        }
    };
};
const subscriberAndNotifierNoPayload = () => {
    let count = 0;
    const myMap = new Map();
    return {
        notify: () => {
            myMap.forEach(fn => fn());
        },
        subscribe: (cb) => {
            const instance = count++;
            myMap.set(instance, cb);
            return () => {
                myMap.delete(instance);
            };
        }
    };
};
//# sourceMappingURL=createEventManager.js.map